/**
 * DialogActions — Button row at the bottom of a Dialog
 *
 * Renders children (typically Button components) in a horizontal row
 * with a top border separator.
 */
import type { ReactNode } from 'react'
import { styled, XStack } from 'tamagui'

const DialogActionsFrame = styled(XStack, {
  name: 'DialogActions',
  gap: '$sm',
  px: '$md',
  py: '$md',
  borderTopWidth: 1,
  borderColor: '$borderColor',
})

interface DialogActionsProps {
  children: ReactNode
}

export function DialogActions({ children }: DialogActionsProps) {
  return (
    <DialogActionsFrame>
      {children}
    </DialogActionsFrame>
  )
}
